import {
  aggregationSUM,
  aggregationAmount,
  getOptions,
  initCalculation,
  sortRecords,
  tranBoolean
} from '@/utils/index'

const canEdit = {
  canEdit: true,
  canModify: true
}
const canModify = {
  canModify: true
}

const columnsLeft = [
  {
    field: 'name',
    title: '预算文件',
    ...canEdit,
    aggregation: aggregationSUM
  },
  {
    field: 'projectUnitName',
    title: '单项工程',
    ...getOptions(
      {
        title: '功能模块',
        key: 'tcbeProjectUnitName',
        async options(vm) {
          const res = await this.$service.get(
            '/construction-budget-estimate/project-unit-cost/list',
            { mainId: this.$parent.$parent.$parent.basicInfo.cbeId }
          )

          return res?.data || []
        },
        confirm(selectedCellInfos, res) {
          const row = res[0][0].originData
          selectedCellInfos.forEach(cells => {
            const obj = cells[0].originData
            this.$set(obj, 'projectUnitName', row.name)
            this.$set(obj, 'projectUnitId', row.id)
          })
        }
      },
      false
    ),
    ...canModify
  },
  {
    field: 'type',
    title: '预算类型',
    ...canEdit,
    ...getOptions({
      title: '预算类型',
      key: 'type',
      options: [
        { name: '施工总包' },
        { name: '专业工程' },
        { name: '直接发包' }
      ]
    })
  },
  {
    field: 'engineeringClassifyName',
    title: '工程分类',
    editModal: {
      columns: [{ field: 'name', title: '工程分类', tree: true }],
      async options() {
        const res = await this.$service.get(
          '/engineering-classify/listAllClassify',
          {}
        )
        return sortRecords(res?.data || [])
      },
      confirm(selectedCellInfos, res) {
        const row = res[0][0].originData
        selectedCellInfos.forEach(cells => {
          const obj = cells[0].originData
          this.$set(obj, 'engineeringClassifyName', row.name)
          this.$set(obj, 'engineeringClassifyId', row.id)
        })
      }
    },
    canModify: true
  },
  {
    field: 'amount',
    title: '总造价',
    aggregation: aggregationAmount
  }
]

const tabsRight = [
  {
    label: '分部分项',
    value: 'constructionCostBudget_fbfx',
    columns: [
      { field: 'code', title: '编码' },
      { field: 'type', title: '类别' },
      { field: 'projectName', title: '项目名称' },
      { field: 'projectDesc', title: '项目特征' },
      { field: 'lockRateFlag', title: '锁定单价', cellType: 'checkbox' },
      { field: 'unit', title: '单位' },
      { field: 'quantity', title: '数量' },
      { field: 'rate', title: '单价' },
      { field: 'amount', title: '金额' }
    ],
    url: '/project-unit-budget/import-bq-item'
  },
  {
    label: '措施项目',
    value: 'constructionCostBudget_csxm',
    columns: [
      { field: 'code', title: '编码' },
      { field: 'type', title: '类别' },
      { field: 'projectName', title: '项目名称' },
      { field: 'projectDesc', title: '项目特征' },
      { field: 'lockRateFlag', title: '锁定单价', cellType: 'checkbox' },
      { field: 'unit', title: '单位' },
      { field: 'quantity', title: '数量' },
      { field: 'rate', title: '单价' },
      { field: 'amount', title: '金额' }
    ],
    url: '/project-unit-budget/import-measure-item'
  },
  {
    label: '费用汇总',
    value: 'constructionCostBudget_fyhz',
    columns: [
      { field: 'seqNum', title: '编码' },
      { field: 'projectName', title: '费用名称' },
      { field: 'baseAmount', title: '取费基数' },
      { field: 'costRatio', title: '费率' },
      { field: 'amount', title: '金额' }
    ],
    url: '/project-unit-budget/import-summary'
  },
  {
    label: '人材机汇总',
    value: 'constructionCostBudget_rcjhz',
    columns: [
      { field: 'code', title: '编码' },
      { field: 'type', title: '类别' },
      { field: 'name', title: '名称' },
      { field: 'spec', title: '规格型号' },
      { field: 'unit', title: '单位' },
      { field: 'quantity', title: '数量' },
      { field: 'rate', title: '单价' },
      { field: 'amount', title: '金额' },
      { field: 'supplyType', title: '供应方式' },
      { field: 'osmQuantity', title: '甲供数量' },
      {
        field: 'lockRateFlag',
        title: '锁定单价',
        cellType: 'checkbox'
      }
    ],
    url: '/project-unit-budget/import-resource'
  },
  {
    label: '工程概况',
    value: 'constructionCostBudget_gkgk',
    columns: [],
    url: ''
  }
]

const tabsBottom = [
  {
    label: '工程量清单',
    value: 'constructionCostBudgetBottom_fbfx',
    columns: [
      { field: 'code', title: '编码', ...canEdit, aggregation: aggregationSUM },
      { field: 'type', title: '类别' },
      { field: 'projectName', title: '项目名称', ...canEdit },
      { field: 'projectDesc', title: '项目特征', ...canEdit },
      {
        field: 'lockRateFlag',
        title: '锁定单价',
        cellType: 'checkbox',
        multiple: true,
        ...canEdit
      },
      { field: 'unit', title: '单位', ...canEdit },
      { field: 'quantity', title: '数量', ...canEdit },
      { field: 'rate', title: '单价', ...canEdit },
      { field: 'amount', title: '金额', aggregation: aggregationAmount },

      { field: 'keywords', title: '关键词' },
      { field: 'percentage', title: '占比' },
      { field: 'totalCost', title: '总造价', aggregation: aggregationAmount },
      { field: 'level1Indicator', title: '一级指标' },
      { field: 'level2Indicator', title: '二级指标' },
      {
        field: 'level3Indicator',
        title: '三级指标',
        editModal: {
          columns: [{ field: 'name', title: '指标项', tree: true }],
          async options() {
            const res = await this.$service.get(
              '/indicator-category/listAll',
              {}
            )
            return sortRecords(res?.data || [])
          },
          confirm(selectedCellInfos, res) {
            const row = res[0][0].originData
            selectedCellInfos.forEach(cells => {
              const obj = cells[0].originData
              this.$set(obj, 'valuationIndicatorCategoryName', row.name)
              this.$set(obj, 'valuationIndicatorCategoryId', row.id)
            })
          }
        },
        ...canModify
      },
      { field: 'billKeywords', title: '清单关键字' },
      { field: 'bname', title: '施工部位' },
      { field: 'hisResourceName', title: '历史材料' },
      { field: 'hisResourceSpec', title: '历史规格型号' },
      { field: 'hisResourceRate', title: '历史单价' },
      { field: 'resourceName', title: '最新材料', ...canEdit },
      { field: 'resourceSpec', title: '最新规格型号', ...canEdit },
      { field: 'resourceRate', title: '最新单价', ...canEdit },
      { field: 'adjustCoefficient', title: '材料价差', ...canEdit },
      // { field: 'adjustRate', title: '调整后单价' },
      {
        field: 'adjustAmount',
        title: '调整后金额',
        aggregation: aggregationAmount
      }
    ],
    url: '/project-unit-budget/new-bq-item'
  },
  // {
  //   label: '措施项目',
  //   value: 'constructionCostBudgetBottom_csxm',
  //   columns: [
  //     { field: 'code', title: '编码', ...canEdit },
  //     { field: 'type', title: '类别' },
  //     { field: 'projectName', title: '项目名称', ...canEdit },
  //     { field: 'projectDesc', title: '项目特征', ...canEdit },
  //     {
  //       field: 'lockRateFlag',
  //       title: '锁定单价',
  //       cellType: 'checkbox',
  //       multiple: true,
  //       ...canEdit
  //     },
  //     { field: 'unit', title: '单位', ...canEdit },
  //     { field: 'quantity', title: '数量', ...canEdit },
  //     { field: 'rate', title: '单价', ...canEdit },
  //     { field: 'amount', title: '金额' },
  //
  //     { field: 'keywords', title: '关键词' },
  //     { field: 'percentage', title: '占比' },
  //     { field: 'totalCost', title: '总造价' },
  //     { field: 'level1Indicator', title: '一级指标' },
  //     { field: 'level2Indicator', title: '二级指标' },
  //     { field: 'level3Indicator', title: '三级指标' },
  //     { field: 'bname', title: '施工部位' },
  //     { field: 'hisResourceName', title: '历史材料' },
  //     { field: 'hisResourceSpec', title: '历史规格型号' },
  //     { field: 'hisResourceRate', title: '历史单价' },
  //     { field: 'resourceName', title: '项目材料', ...canEdit },
  //     { field: 'resourceSpec', title: '项目规格型号', ...canEdit },
  //     { field: 'resourceRate', title: '项目单价', ...canEdit },
  //     { field: 'adjustCoefficient', title: '调整系数', ...canEdit },
  //     { field: 'adjustRate', title: '调整后单价' },
  //     { field: 'adjustAmount', title: '调整后金额' }
  //   ],
  //   url: '/project-unit-budget/new-measure-item'
  // },
  {
    label: '费用汇总',
    value: 'constructionCostBudgetBottom_fyhz',
    columns: [
      { field: 'seqNum', title: '编码', ...canEdit },
      { field: 'projectName', title: '费用名称', ...canEdit },
      { field: 'baseAmount', title: '取费基数', ...canModify },
      { field: 'costRatio', title: '费率', ...canEdit },
      { field: 'amount', title: '金额', ...canEdit }
    ],
    url: '/project-unit-budget/new-summary'
  },
  {
    label: '人材机汇总',
    value: 'constructionCostBudgetBottom_rcjhz',
    columns: [
      {
        field: 'projectUnitName',
        title: '单项工程',
        aggregation: aggregationSUM
      },
      { field: 'fileName', title: '预算文件' },
      { field: 'code', title: '编码' },
      { field: 'type', title: '类别' },
      { field: 'name', title: '名称' },
      { field: 'spec', title: '规格型号' },
      { field: 'unit', title: '单位' },
      { field: 'quantity', title: '数量' },
      { field: 'rate', title: '单价' },
      { field: 'amount', title: '金额', aggregation: aggregationAmount },
      {
        field: 'supplyType',
        title: '供应方式',
        ...canEdit,
        ...getOptions({
          title: '供应方式',
          key: 'supplyType',
          options: [
            { name: '自行采购' },
            { name: '甲供材料' },
            { name: '甲指乙供' }
          ]
        })
      },
      { field: 'osmQuantity', title: '甲供数量', ...canEdit },
      {
        field: 'lockRateFlag',
        title: '锁定单价',
        cellType: 'checkbox',
        multiple: true,
        ...canEdit
      },
      { field: 'nameKeywords', title: '关键词' }
    ],
    url: '/project-unit-budget/new-resource'
  },
  {
    label: '甲供材料',
    value: 'constructionCostBudgetBottom_jgcl',
    columns: [
      {
        field: 'projectUnitName',
        title: '单项工程',
        aggregation: aggregationSUM
      },
      { field: 'fileName', title: '预算文件' },
      { field: 'code', title: '编码' },
      { field: 'type', title: '类别' },
      { field: 'name', title: '名称' },
      { field: 'spec', title: '规格型号' },
      { field: 'unit', title: '单位' },
      { field: 'quantity', title: '数量' },
      { field: 'rate', title: '单价' },
      { field: 'amount', title: '金额', aggregation: aggregationAmount },
      { field: 'supplyType', title: '供应方式' },
      { field: 'osmQuantity', title: '甲供数量' },
      {
        field: 'lockRateFlag',
        title: '锁定单价',
        cellType: 'checkbox',
        multiple: true
      },
      { field: 'nameKeywords', title: '关键词' }
    ],
    url: '/project-unit-budget/new-resource'
  }
]

const columnsQdLeft = [
  {
    field: 'name',
    title: '名称',
    width: 250,
    tree: true, // 启用树形结构
    headerStyle: {
      textAlign: 'center' // 标题居中
    },
    style: {
      textAlign: 'left' // 内容左对齐（树形结构需要）
    }
  }
]
const columnsQdRight = [
  {
    field: 'code',
    title: '编码',
    width: 'auto'
  },
  {
    field: 'name',
    title: '名称',
    width: 'auto'
  },
  {
    field: 'measurementUnit',
    title: '计量单位',
    width: 'auto'
  },
  {
    field: 'partyaCategoryName',
    title: '甲方分类'
  },
  {
    field: 'constructionGroupName',
    title: '施工班组'
  },
  {
    field: 'valuationIndicatorCategoryName',
    title: '计价指标分类'
  },
  {
    field: 'measurementIndicatorCategoryName',
    title: '计量指标分类'
  }
]

const columnsZmLeft = [
  {
    field: 'name',
    title: '名称',
    width: 250,
    tree: true, // 启用树形结构
    headerStyle: {
      textAlign: 'center' // 标题居中
    },
    style: {
      textAlign: 'left' // 内容左对齐（树形结构需要）
    }
  }
]
const columnsZmRight = [
  {
    field: 'code',
    title: '编码',
    width: 'auto'
  },
  {
    field: 'newType',
    title: '类别',
    width: 'auto'
  },
  {
    field: 'name',
    title: '名称',
    width: 'auto'
  },
  // {
  //   field: 'spec',
  //   title: '规格型号',
  //   width: 'auto'
  // }
  {
    field: 'unit',
    title: '单位'
  }
  // {
  //   field: 'constructionGroupName',
  //   title: '含量'
  // }
]

export {
  columnsLeft,
  tabsRight,
  tabsBottom,
  columnsQdLeft,
  columnsQdRight,
  columnsZmLeft,
  columnsZmRight
}
